import React from 'react';
import { SMLPublishingModalRendererProps } from './props';
import { TypedMemo } from '../../../types';
import { SMLPublishedModal } from '../../../../smartLinks/published/SMLPublishedModal';

/**
 * Web and Electron get the published sheet; React Native keeps the modal it
 * had. The sheet leans on an iframe of the live page, a client-side QR code and
 * the catalog, none of which the mobile app can show today.
 */
const SMLPublishingModalRendererComponent: React.FC<SMLPublishingModalRendererProps> = ({
  isOpen,
  closeModal,
  accountId,
  smartLink,
  openSmartLink,
}) => (
  <SMLPublishedModal
    isOpen={isOpen}
    accountId={accountId}
    smartLink={smartLink}
    closeModal={closeModal}
    openSmartLink={openSmartLink}
  />
);

export const SMLPublishingModalRenderer = TypedMemo(SMLPublishingModalRendererComponent);
